import { NgIf } from '@angular/common';
import { Component, Input } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';

import { NzButtonModule } from 'ng-zorro-antd/button';

import { environment } from '@env/environment';

import { Alert } from '@app/alerts/state/alerts-state.models';
import { getCurrentStage } from '@app/core/utilities/url.utilities';

@Component({
  selector: 'adspt-alerts-actions',
  templateUrl: './alerts-actions.component.html',
  styleUrls: ['./alerts-actions.component.scss'],
  imports: [TranslateModule, NzButtonModule, NgIf],
})
export class AlertsActionsComponent {
  @Input()
  alert?: Alert;

  isExternalLink(link: string): boolean {
    return !link.includes(environment.app.stages[getCurrentStage()].appBaseURL);
  }
}
